// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminUsers from "../../components/dashboard/AdminUsers";

export default function AdminUsersPage() {
  return (
    <DashboardLayout>
      <AdminUsers />
    </DashboardLayout>
  );
}
